// date-range.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateDatePipe } from './translate-date.pipe';

@Pipe({
  name: 'dateRange'
})
export class DateRangePipe implements PipeTransform {
  constructor(private translateDate: TranslateDatePipe) {}

  transform(startDate: Date, endDate: Date, showTranslation: boolean = false, secondLanguage: string = ''): string {
    if (!endDate || this.isSameDay(startDate, endDate)) {
      return this.translateDate.transform(startDate, showTranslation, secondLanguage, 'mediumDate');
    }

    if (this.isSameMonth(startDate, endDate) && this.isSameYear(startDate, endDate)) {
      
      const startStr = this.translateDate.transform(startDate, showTranslation, secondLanguage, 'MMMM d');
      const endStr = this.translateDate.transform(endDate, showTranslation, secondLanguage, 'd, yyyy');
      return `${startStr}-${endStr}`;
    }

    const startStr = this.translateDate.transform(startDate, showTranslation, secondLanguage, 'mediumDate');
    const endStr = this.translateDate.transform(endDate, showTranslation, secondLanguage, 'mediumDate');
    return `${startStr} - ${endStr}`;
  }

  private isSameDay(d1: Date, d2: Date): boolean {
    return d1.getDate() === d2.getDate() 
      && d1.getMonth() === d2.getMonth()
      && d1.getFullYear() === d2.getFullYear();
  }

  private isSameMonth(d1: Date, d2: Date): boolean {
    return d1.getMonth() === d2.getMonth() 
      && d1.getFullYear() === d2.getFullYear();
  }

  private isSameYear(d1: Date, d2: Date): boolean {
    return d1.getFullYear() === d2.getFullYear();
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/date-range.pipe.ts